<div class="container">
  <div class="header sticky-header">
    <div class="title">
      <div class="section-name">{{'TO_DO' | translate}}</div>
      <div class="count">{{filteredTodoItems?.length ?? 0}}</div>
    </div>
    <div>
      <ion-buttons slot="end">
        <ion-button class="search-button" [ngClass]="{'selected': showSearch}" icon-only
          (click)="onClickSearch($event)">
          <ion-icon src="assets/imgs/search-grey-icon.svg" class="search-icon"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
  <div *ngIf="showSearch" class="search-bar-container">
    <ion-searchbar autoFocusSearchbar [(ngModel)]="searchText" (ionInput)="onSearchInput($event)" placeholder="{{'TO_DO' | translate}}"
      show-clear-button="never" class="home-screen-searchbar"></ion-searchbar>
    <ion-icon *ngIf="searchText?.length > 0" name="close-outline" class="home-screen-close-icon"
      (click)="clearSearchBar()"></ion-icon>
  </div>
  <ng-container *ngIf="deltaService.isInitialSyncFinished; else skeleton">
    <div class="filters sticky-header" [ngClass]="{'searchActiveFilters': showSearch}">
      <ion-button class="filter-button" fill="clear" [ngClass]="{'selected': option.selected}"
        *ngFor="let option of filterOptions; trackBy: trackByFilterId" (click)="onFilterClick(option)">
        <span class="filter">{{option.name}}</span>
      </ion-button>
    </div>
    <div class="scrollable-content">
      <ng-container *ngIf="todoItems$?.value?.length > 0">
        <virtual-list #todoList class="allow-scroll-bar" [source$]="todoItems$" (update)="viewPortItems = $event" [height]="'off'"
          [visibleChildren]="20" [bufferAmount]="5" [childHeight]="90">
          <div #item *ngFor="let todoItem of viewPortItems; trackBy: trackById">
            <main-card [viewData]="getActivityMainCard(todoItem)"></main-card>
          </div>
        </virtual-list>
      </ng-container>
      <p *ngIf="todoItems$?.value?.length == 0" class="no-data-message">
        {{'NO_TO_DO_ITEMS' | translate}}
      </p>
    </div>
  </ng-container>
  <ng-template #skeleton>
    <div class="filters sticky-header">
      <ng-container *ngFor="let i of [].constructor(5); trackBy: trackById">
        <ion-skeleton-text animated style="width: 50%; height: 16px; margin-right: 10px;"
          class="skeleton-text-animated filter-button"></ion-skeleton-text>
      </ng-container>
    </div>
    <div class="scrollable-content">
      <ion-list>
        <ind-section-header [isSkeleton]="true"></ind-section-header>
        <ng-container *ngFor="let i of [].constructor(15); trackBy: trackById">
          <main-card [isSkeleton]="true"></main-card>
        </ng-container>
      </ion-list>
    </div>
  </ng-template>

</div>